export default {
	add_to_your_calendar: "Añadir a tu calendario",
	explore_all_our_universe_of_courses_videos_articles_and_exclusive_files: "Explora nuestro universo de entrenamientos, videos, artículos y archivos exclusivos.",
	home_drills_title: "Drills",
	home_events_title: "Mis Eventos",
	home_keep_watching_title: "Continuá viendo",
	home_library_title: "Biblioteca",
	home_live_classes_title: "Clases en Vivo",
	home_news_title: "Novedades",
	home_online_courses_title: "Cursos Online",
	home_podcasts_title: "Podcasts",
	home_surveys_title: "Búsquedas",
	home_tags_title: "Destacados",
	home_trails_title: "Módulos de Capacitación",
	home_webinars_title: "Webinars",
	no_events_available_for_the_selected_date: "No hay eventos disponibles.",
	welcome_to: "Bienvenido(a) a",
	what_do_you_want_to_learn_today: "¿Qué quieres aprender hoy?"
}